import { render, staticRenderFns } from "./SankeyDiagram.vue?vue&type=template&id=2917d0d2&scoped=true"
import script from "./SankeyDiagram.vue?vue&type=script&lang=ts"
export * from "./SankeyDiagram.vue?vue&type=script&lang=ts"
import style0 from "./SankeyDiagram.vue?vue&type=style&index=0&id=2917d0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2917d0d2",
  null
  
)

export default component.exports